'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var actionTypes = require('./actionTypes.js');

var sortList = function (sortBy, sortType, sortDirection) { return ({
    type: actionTypes.ActionTypes.SORT_LIST,
    sortBy: sortBy,
    sortType: sortType,
    sortDirection: sortDirection
}); };
var filterList = function (filter) { return ({
    type: actionTypes.ActionTypes.FILTER_LIST,
    filter: filter
}); };
var setItemsPerPage = function (itemsPerPage) { return ({
    type: actionTypes.ActionTypes.SET_ITEMS_PER_PAGE,
    itemsPerPage: itemsPerPage
}); };
var setCurrentPage = function (currentPage, pageRecords) { return ({
    type: actionTypes.ActionTypes.SET_CURRENT_PAGE,
    currentPage: currentPage,
    pageRecords: pageRecords
}); };

exports.filterList = filterList;
exports.setCurrentPage = setCurrentPage;
exports.setItemsPerPage = setItemsPerPage;
exports.sortList = sortList;
//# sourceMappingURL=actions.js.map
